import { render } from "./App.vue?vue&type=template&id=59b296e7&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=59b296e7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\holo\\work\\git-all-source,\\stress_check_Rebuild\\source\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b296e7"]])

export default __exports__